import { Alert } from '@creditornot/cb-alert';
import { Tag } from '@creditornot/cb-tag';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { usePluralization } from 'common/hooks';
import { useScopeContext } from 'modules/shared-menu/contexts/ScopeContext';
import { VenueWithSharedMenuLinkInfo } from 'modules/shared-menu/hooks/useVenuesWithSelectionLinks';

type UnassignedVenuesProps = {
  onClickShowVenues: () => void;
  unassignedVenues: VenueWithSharedMenuLinkInfo[];
};

const ShowVenuesButton = styled(Tag)`
  cursor: pointer;
`;

export const UnassignedVenuesInfo = ({ onClickShowVenues, unassignedVenues }: UnassignedVenuesProps) => {
  const { FormattedPluralMessage } = usePluralization();
  const scope = useScopeContext();

  return (
    <Alert
      style={{ margin: '16px 16px 0 16px' }}
      variant="info"
      size="medium"
      titleRightContent={
        <ShowVenuesButton variant="outlineBlack" size="small" onClick={onClickShowVenues}>
          <FormattedMessage id="listing-manager.unassigned-venues.info.show-venues" />
        </ShowVenuesButton>
      }
    >
      <div>
        <FormattedPluralMessage
          id={
            scope.type === 'brand'
              ? 'listing-manager.unassigned-venues.info.brand'
              : 'listing-manager.unassigned-venues.info.merchant'
          }
          count={unassignedVenues.length}
        />
      </div>
    </Alert>
  );
};
